import { render, staticRenderFns } from "./FormControlLowercase.vue?vue&type=template&id=8ca06e34"
import script from "./FormControlLowercase.vue?vue&type=script&lang=js"
export * from "./FormControlLowercase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports